// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';
import Models from "../../models";

// Data
const state = {
	podcasts:[],
	podcast: Models.Resource('Podcast'),
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getPodcasts: ({ dispatch }) => {
		api.podcasts.index()
			.then(response => dispatch('setPodcasts', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getPodcast: ({ dispatch }, id) => {
		api.podcasts.show(id)
			.then(response => dispatch('setPodcast', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
